import classNames from 'classnames';
import React from 'react';
import failureSrc from './failed-ad.png';
import successSrc from './successful-ad.png';
import styles from './HowXRayWorksVersionB.module.css';

type Props = {
  isWhiteLabel?: boolean;
};

export const HowXRayWorksVersionB = ({ isWhiteLabel }: Props) => (
  <div className={styles.container}>
    <div className={classNames(styles.block, styles.lightRed)}>
      <div className={classNames(styles.tag, styles.red)}>
        Using basic CAPI + Meta Pixel{' '}
      </div>
      <div className={styles.heading}>
        $100 campaign with a 3.7 Quality Score
      </div>
      <img src={failureSrc} alt="Failure" className={styles.image} />
    </div>
    <div className={classNames(styles.block, styles.lightGreen)}>
      <div className={classNames(styles.tag, styles.green)}>
        27% ad improvement with{' '}
        {isWhiteLabel ? 'our tool' : 'Customers.ai Super-CAPI Pixel'}{' '}
      </div>
      <div className={styles.heading}>
        Campaign with a 7.5 Quality Score with{' '}
        {isWhiteLabel ? 'our tool' : 'Customers.ai'}
      </div>
      <img src={successSrc} alt="Success" className={styles.image} />
    </div>
  </div>
);
